export default function since(date) {
    if (!date) return null

    const then = new Date(date)
    const now = new Date()

    if (Number.isNaN(then.getTime())) return null

    const isToday =
        then.getFullYear() === now.getFullYear() &&
        then.getMonth() === now.getMonth() &&
        then.getDate() === now.getDate()

    const formatTime = () => {
        return new Intl.DateTimeFormat('ar-SA', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).format(then)
    }

    // اليوم: الوقت فقط
    if (isToday) {
        return formatTime()
    }

    // هذه السنة: اليوم + الشهر + الوقت
    if (then.getFullYear() === now.getFullYear()) {
        return new Intl.DateTimeFormat('ar-SA', {
            day: '2-digit',
            month: 'long',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).format(then)
    }

    // سنة مختلفة: التاريخ الكامل المختصر + الوقت
    return new Intl.DateTimeFormat('ar-SA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    }).format(then)
}
